import { TProjectEditorState } from 'shared/reducers';

export const selectProjectTitle = (state: TProjectEditorState) => {
  return state.title;
};
